import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
/*
 * Transform a month number into a month name
 * Takes an month argument that defaults to 1.
 * Usage:
 *   value | wpMonthName:format
 * Example:
 *   {{ 10 |  monthName:'MMM-y' }}
 *   formats to: Oct
*/
@Pipe({
  name: 'wpMonthName'
})
export class MonthNamePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {}

  transform(month: number, format: string): string | null {
    // MMM default format
    let form = !format ? 'MMM' : format;
    return this.datePipe.transform(new Date(0, month), form);
  }
}
